import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const EduBlogsIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3789_25778)">
      <path
        d="M49.0833 5.1665H12.9167C5.78667 5.1665 0 10.9532 0 18.0832V43.9165C0 51.0465 5.78667 56.8332 12.9167 56.8332H49.0833C56.2133 56.8332 62 51.0465 62 43.9165V18.0832C62 10.9532 56.2133 5.1665 49.0833 5.1665ZM12.9167 10.3332H49.0833C53.3458 10.3332 56.8333 13.8207 56.8333 18.0832H5.16667C5.16667 13.8207 8.65417 10.3332 12.9167 10.3332ZM49.0833 51.6665H12.9167C8.65417 51.6665 5.16667 48.179 5.16667 43.9165V23.2498H56.8333V43.9165C56.8333 48.179 53.3458 51.6665 49.0833 51.6665ZM25.8333 30.9998C25.8333 32.4207 24.6708 33.5832 23.25 33.5832H20.6667V43.9165C20.6667 45.3373 19.5042 46.4998 18.0833 46.4998C16.6625 46.4998 15.5 45.3373 15.5 43.9165V33.5832H12.9167C11.4958 33.5832 10.3333 32.4207 10.3333 30.9998C10.3333 29.579 11.4958 28.4165 12.9167 28.4165H23.25C24.6708 28.4165 25.8333 29.579 25.8333 30.9998ZM51.6667 30.9998C51.6667 32.4207 50.5042 33.5832 49.0833 33.5832H33.5833C32.1625 33.5832 31 32.4207 31 30.9998C31 29.579 32.1625 28.4165 33.5833 28.4165H49.0833C50.5042 28.4165 51.6667 29.579 51.6667 30.9998ZM51.6667 41.3332C51.6667 42.754 50.5042 43.9165 49.0833 43.9165H33.5833C32.1625 43.9165 31 42.754 31 41.3332C31 39.9123 32.1625 38.7498 33.5833 38.7498H49.0833C50.5042 38.7498 51.6667 39.9123 51.6667 41.3332Z"
        fill={props.color ? props.color : colors.uguPurple}
        stroke="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3789_25778">
        <rect width="62" height="62" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
